import React, { useState, useEffect } from 'react'
import { Col, Row } from 'reactstrap'
import LoaderCustom from '../../../../../../common/LoaderCustom';
import { showYesOrNoLabel } from '../../../../../../../helper';

function BusinessDetailsView(props) {
    let businessDetails = props?.supplierDetail?.Data?.BusinessDetails;
    const [showTabLoader, setShowTabLoader] = useState(true);

    useEffect(() => {
        if (props.supplierDetail?.IsSuccessful) {
            setShowTabLoader(false);
        }
    }, [props.supplierDetail?.IsSuccessful])


    return (
        <>
            {showTabLoader && (<LoaderCustom customClass="simulation-Loader hl-loader-fixed" />)}
            <Row>
                <Col xs={12} md={12}>
                    <Row>
                        <Col span={12} xl={12}>
                            <h3 className="sd-common-heading">Nature of Business with Havells</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">For Goods</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span class="hl-desc-details pe-0 ps-0 hl-multi-val">
                                <span class="ps-3">{businessDetails?.ManufacturerForGoods ? "Manufacturer" : "-"}</span>
                                <span class="ps-3">{businessDetails?.TraderForGoods ? "Trader" : "-"}</span>
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">For Services</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span class="hl-desc-details pe-0 ps-0 hl-multi-val">
                                <span class="ps-3">{businessDetails?.OwnForService ? "Own" : "-"}</span>
                                <span class="ps-3">{businessDetails?.OutSourceForService ? "Outsource" : "-"}</span>
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Do you have another Sister Concern which is Supplying to Havells Group?</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className={`hl-desc-details d-block pe-0 ps-0`}>
                                {showYesOrNoLabel(businessDetails?.IsOtherSisterConcern) && (
                                    <p className={`${businessDetails?.IsOtherSisterConcern && businessDetails?.OtherSisterConcern ? 'hl-descmain-details pb-2 mb-2 mw-100' : ''} d-flex`}>
                                        <span className="ps-3">{showYesOrNoLabel(businessDetails?.IsOtherSisterConcern)}</span>
                                    </p>
                                )}
                                {
                                    businessDetails?.IsOtherSisterConcern && businessDetails?.OtherSisterConcern.map((el) => {
                                        return (
                                            <>
                                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                    <span className="ps-3 text-uppercase">{el?.VendorCode}</span>
                                                    <span className="ps-3 text-center">{el?.VendorName}</span>
                                                    <span className="ps-3 text-center">{el?.Mobile}</span>
                                                </p>
                                            </>
                                        )
                                    })
                                }
                            </span>

                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Do you have another Relationship with any Havells Employees?</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className={`hl-desc-details d-block pe-0 ps-0`}>
                                {showYesOrNoLabel(businessDetails?.IsAnyRelationWithQRG) && (
                                    <p className={`hl-multi-val d-flex ${businessDetails?.IsAnyRelationWithQRG ? 'hl-descmain-details pb-2 mb-2 mw-100' : ''}`}>
                                        <span className="ps-3">{showYesOrNoLabel(businessDetails?.IsAnyRelationWithQRG)}</span>
                                    </p>
                                )}

                                {
                                    businessDetails?.IsAnyRelationWithQRG && (
                                        <>
                                            <p className="hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100">
                                                {
                                                    !businessDetails?.RelationShipName && !businessDetails?.EmployeeCode ? (
                                                        <span className="ps-3">-</span>
                                                    ) : (
                                                        <>
                                                            <span className="ps-3">{businessDetails?.RelationShipName || '-'}</span>
                                                            <span className="ps-3 text-uppercase">{businessDetails?.EmployeeCode || '-'}</span>
                                                        </>
                                                    )
                                                }
                                            </p>
                                            <p className="hl-multi-val d-flex mt-2 w-100">
                                                {
                                                    !businessDetails?.EmployeeName && !businessDetails?.EmployeeLocation ? (
                                                        <span className="ps-3">-</span>
                                                    ) : (
                                                        <>
                                                            <span className="ps-3">{businessDetails?.EmployeeName || '-'}</span>
                                                            <span className="ps-3">{businessDetails?.EmployeeLocation || '-'}</span>
                                                        </>
                                                    )
                                                }
                                            </p>
                                        </>
                                    )
                                }
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details hl-multi-val"><span>Total Staff</span><span>Total Workers</span></span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className={`hl-desc-details pe-0 ps-0 hl-multi-val`}>
                                {
                                    !businessDetails?.TotalStaff && !businessDetails?.TotalWorkers ? (
                                        <span className="ps-3">-</span>
                                    ) : (
                                        <>
                                            <span className="ps-3">{businessDetails?.TotalStaff || '-'}</span>
                                            <span className="ps-3">{businessDetails?.TotalWorkers || '-'}</span>
                                        </>
                                    )
                                }
                            </span>
                        </Col>
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Supplier Specialization</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details">{businessDetails?.SupplierSpecializationName || '-'}</span>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}

export default BusinessDetailsView